export enum EVENT {
  DRAG_ENTER = 'dragenter',
  DRAG_OVER = 'dragover',
  DRAG_LEAVE = 'dragleave',
  DROP = 'drop',
}
